import { Stack, Typography } from '@mui/material';
import { type EventType } from '@/types/dtos/events/event-type.enum';
import { useTranslations } from '@/i18n/use-translations';
import { eventTypeToIcon } from '@/components/events/helpers/event-type-to-icon';

interface EventTypeInfoProps {
  type: EventType;
  showDescription?: boolean;
}

const EventTypeInfo: React.FC<EventTypeInfoProps> = ({ type, showDescription = true }) => {
  const t = useTranslations();
  const description = t(`event.typeDescriptions.${type}`);

  const iconElement = eventTypeToIcon(type);
  const title = t(`event.types.${type}`);

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Stack sx={{ fontSize: 24 }}>{iconElement}</Stack>

      <Stack spacing={0.25} sx={{ flex: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
        {showDescription && (
          <Typography variant="body2" color="text.primary" sx={{ fontSize: '0.875rem' }}>
            {description}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default EventTypeInfo;
